import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=be813d3c&scoped=true"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"
import style0 from "./custom.vue?vue&type=style&index=0&id=be813d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be813d3c",
  null
  
)

export default component.exports